module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/11_77b4bee4feac71f092a32ccbe727ff59.jpg";